import { useState } from "react";
import { Box, FormControlLabel, Switch } from "@mui/material";
import { Layout, Text } from "$components";
import useJStyles from "$hooks/useJStyles";

import { theme } from "$utils/theme/bataillog";
import Navigation from "./Navigation";
import Texts from "./Texts";
import Selectors from "./Selectors";
import Components from "./Components";
import Block from "./Block";
import Colors from "./Colors";

function GraphicComponents() {
  const { jclasses } = useJStyles();
  const [withJWrapper, setWithJWrapper] = useState(true);

  const handleNavClick = (id: string) => {
    const element = document.querySelector(`#${id}`);
    const dims = element.getBoundingClientRect();
    // Manual hack to scroll just above the section
    const manualMargin = 80;
    window.scrollTo(window.scrollX, dims.top - manualMargin + window.scrollY);
  };

  return (
    <div className={withJWrapper ? jclasses.jWrapper : ""}>
      <Layout title="Catalogue de composants graphiques">
        <Navigation onItemClick={handleNavClick} />
        <Texts />
        <Colors />

        <Block id="" title="">
          <FormControlLabel
            control={
              <Switch
                checked={withJWrapper}
                onChange={() => setWithJWrapper(!withJWrapper)}
                color="primary"
              />
            }
            label="Activer le jWrapper"
          />
          <Box
            display="flex"
            flexDirection="column"
            style={{ gap: theme.spacing(2) }}
          >
            <Text>
              <i>{`Le jWapper est un ensemble de règles de design propres à Batail-Log
            qui changent radicalement l'apparence de certains éléments.`}</i>
            </Text>
            <Text>
              <i>{`On pourrait envisager 
            que celui-ci disparaisse à terme et soit inclus par
            défaut dans toute l'application.`}</i>
            </Text>
          </Box>
        </Block>

        <Selectors />
        <Components />
      </Layout>
    </div>
  );
}

export default GraphicComponents;
